import React from 'react';
import ReactDOM from 'react-dom';
import 'semantic-ui-css/semantic.min.css'
import 'bulma/css/bulma.min.css'
import Home from './Components/Home'

ReactDOM.render(<Home/>, document.getElementById('root'));
